<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 17px; margin-bottom: 15px;">
      <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
      <el-breadcrumb-item>公网IP地址</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-button type="primary" @click="addIpAddr"
                   v-if="btnInList('idc_pubIpAddr','idc_pubIpAddr_add')">新增IP地址</el-button>
        <el-button v-if="btnInList('idc_pubIpAddr','idc_pubIpAddr_import')">导入</el-button>
        <el-button v-if="btnInList('idc_pubIpAddr','idc_pubIpAddr_export')">导出</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="width: 100%"
              row-key="rowKey"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column align="center" prop="id" label="ID" width="180"></el-table-column>
      <el-table-column align="center" prop="ipStr" label="IP地址" width="180"></el-table-column>
      <el-table-column align="center" prop="ispName" label="ISP信息"></el-table-column>
      <el-table-column align="center" label="映射端口">
        <template slot-scope="scope">
          {{convertPortStr(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="IP类型">
        <template slot-scope="scope">
          {{convertIpStr(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="netPlaneName" label="所属网络平面"></el-table-column>
      <el-table-column align="center" label="操作" width="260">
        <template v-slot="{row}">
          <el-button v-if="row.ipType == 1 && btnInList('idc_pubIpAddr','idc_pubIpAddr_relevance')"
                     size="mini" type="primary" @click="contact(row)">关联网络平面</el-button>
          <el-button v-if="row.ipType == 1 && btnInList('idc_pubIpAddr','idc_pubIpAddr_edit')"
                     size="mini" type="primary" @click="editIP(row)">编辑</el-button>
          <el-button v-if="row.ipType == 1 && btnInList('idc_pubIpAddr','idc_pubIpAddr_del')"
                     size="mini" type="danger" @click="delIpConfirm(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

    <el-dialog
      :title="addIPAddr"
      :visible="ipaddr"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px">
      <el-form label-position="left" style="margin-left: 25px;width:350px" :model="formData" ref="formData" label-width="70px" :rules="rules">
        <el-form-item label="IP地址" prop="ipStr" style="width: 290px">
          <el-input v-model="formData.ipStr" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="ISP" prop="ispId">
          <el-select v-model="formData.ispId" placeholder="请选择">
            <el-option v-for="(option, idx) in ispList"
                       :key="idx"
                       :label="option.IspName"
                       :value="option.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-collapse v-model="activePortNames">
            <el-collapse-item title="端口" name="2" style="width: 350px">
              <div v-for="(port, index) in formData.ports" :key="index">
                <el-col :span="20" class="portDiv">
                  <el-form-item :prop="'ports.'+index+'.value'" :rules="rules.port" style="width: 200px">
                    <el-input v-model="port.value" placeholder="请输入端口号"  type="number" min="0" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon">
                  <div class="el-icon-circle-plus" @click="addPort"></div>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon" v-if="formData.ports.length > 1">
                  <div class="el-icon-delete-solid" @click="delPort(index)"></div>
                </el-col>
              </div>
            </el-collapse-item>
            <!--          </el-form-item>-->
            <el-collapse-item title="端口范围" name="1" style="width: 350px">
              <div v-for="(range, index) in formData.portRange" :key="index">
                <el-col :span="9" class="portDiv">
                  <el-form-item :prop="'portRange.'+index+'.start'" :rules="rules.port">
                    <el-input v-model="range.start" type="number" min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col align="center" :span="2">-</el-col>
                <el-col :span="9" class="portDiv">
                  <el-form-item :prop="'portRange.'+index+'.end'" :rules="rules.port">
                    <el-input v-model="range.end" type="number" min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon">
                  <div class="el-icon-circle-plus" @click="addRange"></div>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon" v-if="formData.portRange.length > 1">
                  <div class="el-icon-delete-solid" @click="delRange(index)"></div>
                </el-col>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="saveIp('formData')">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
<!--    关联网络平面-->
    <el-dialog
      :title="'关联网络平面'"
      :visible="netcontact"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%">
      {{ selectNetplane }}
      <span style="position:absolute; right:30px; top:50px;">
        <el-button size="mini" type="primary" @click="skip">跳转到共有网络平面</el-button>
      </span>
      <el-tabs v-model="netPlane">
        <el-tab-pane label="共有网络平面" name="public">
          <el-table
            ref="singleTable"
            :data="wanNetPlaneList"
            highlight-current-row
            @current-change="selectCurrentChange"
            style="width: 100%">
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column align="center" property="id" label="ID"></el-table-column>
            <el-table-column align="center" property="netPlaneName" label="网络平面名称"></el-table-column>
            <el-table-column align="center" property="remark" label="描述"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-row style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="saveIpBindNetPlane()">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
  export default {
    name: "PublicIpList",
    data() {
      let IPValidator = (rule, value, callback) => {
        let ip_ip = '(25[0-5]|2[0-4]\\d|1\\d\\d|\\d\\d|\\d)';
        let ip_ipdot = ip_ip + '\\.';
        let isIPaddress = new RegExp('^' + ip_ipdot + ip_ipdot + ip_ipdot + ip_ip + '$');
        if(value == ""){
          callback(new Error('IP地址格式错误'));
          return
        }else if (value && !isIPaddress.test(value)) {
          callback(new Error('IP地址格式错误'));
          return
        } else {
          callback();
        }
      };
      let validateAddport = (rule, value, callback) => {
        if (value == '') {
          callback();
          return
        }
        const val = Number(value)
        if (val<0 || val>65535){
          callback(new Error('端口范围为 0-65535'));
          return;
        }
        //field---0.portRange/ports   1.下标  2.value/start/end
        const field = rule.field.split('.')
        const ports = this.formData.ports
        const portRange = this.formData.portRange
        let arr = new Set() //所有的端口
        let broPort = [], broRange = [] //兄弟端口
        let flag = 0
        if (field[0] == 'ports') {
          broPort = ports.filter((p, id) => id != Number(field[1]))
          broRange = portRange
        } else {
          broPort = ports
          broRange = portRange.filter((pr, id) => id != Number(field[1]))
        }
        broPort.forEach(b => {
          if (b.value == null) {
            return
          }
          arr.add(Number(b.value))
        })
        broRange.forEach(br => {
          if (br.start == null || br.end == null) {
            return
          }
          for (let i = Number(br.start); i <= Number(br.end); i++) {
            arr.add(i)
          }
        })

        if (arr.has(val)) {
          callback(new Error('该端口已存在'))
          return
        } else if (field[0] == 'ports') {
          flag = 1
          arr.add(val)
        } else {
          let start, end
          if (field[2] == 'start') {
            start = val
            end = Number(this.formData.portRange[field[1]].end)
          } else {
            end = val
            start = Number(this.formData.portRange[field[1]].start)
          }
          if (start != '' && end != '') {
            if (start >= end) {
              callback(new Error('开始端口小于结束端口'))
              return
            }
            let note = 0
            for (let i = start; i <= end; i++) {
              if (arr.has(i)) {
                note = 1
                break;
              }
            }
            if (note == 0) {
              flag = 1
              for (let i = start; i <= end; i++) {
                arr.add(i)
              }
            } else {
              callback(new Error('端口已存在'))
            }
          }else if(start == '' && end == ''){
            flag = 1
          }
        }
        if (flag == 1) {
          callback()
        }
      }
      return {
        selectNetplane:"",
        idcId: 0,
        ipaddr: false,
        netcontact: false,
        ipItem: null,
        condition: "",
        addIPAddr:"",
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        netPlane: 'public',
        netplaneId: 0,
        currentRow: null,
        wanNetPlaneList: [],
        netPlaneList: [],
        ispList: [],
        tableData: [],
        portFormData: {
          ports: []
        },
        activePortNames: [],
        formData: {
          ipStr: "",
          ispId: "",
          idcId: "",
          portArray: "",
          ports: [{
            value: null
          }],
          portRange: [{
            start: null,
            end: null
          }]
        },
        rules: {
          port: [{validator: validateAddport, trigger: 'blur'}],
          ispId: [{ required: true, message: '请选择isp', trigger: 'blur' }],
          ipStr: [{ required: true, message: '请输入正确IP地址',validator: IPValidator, trigger: 'blur' }]
        }
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      // 操作按钮是否可以显示
      btnInList() {
        return (name, childName) => {
          let btn = this.listOperations.filter(op => op.name.includes(name));
          if(btn && btn.length>0){
            if (!childName) {
              return btn.length > 0
            } else {
              return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
            }
          }
        }
      },
    },
    methods: {
      ...mapMutations(['getListOperations']),
      editIP(item){
        this.id = item.id;
        this.addIPAddr = "编辑IP地址";
        this.ipaddr = true
        this.netPlaneId = item.netPlaneId
        let data = {
          id: this.id
        }
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netip/get', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.ipaddr = true;
              _this.formData.ipStr = data.ipStr;
              _this.formData.ispId = data.ispId;
              if(data.portArray){
                _this.formData.ports = [];
                data.portArray.forEach(e => {
                  _this.formData.ports.push({
                    value: e
                  })
                })
              }else {
                _this.formData.ports = [{
                  value: null
                }];
              }
              if(data.portRange){
                _this.formData.portRange = [];
                data.portRange.forEach(e => {
                  _this.formData.portRange.push({
                    start: e.start,
                    end: e.end
                  })
                })
              }else {
                _this.formData.portRange=[{
                  start: null,
                    end: null
                }]
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      skip() {
        this.$router.push({
          path: 'pubenetplane',
          name: 'pubenetplane'
        })
      },
      addIpAddr() {
        this.id=0;
        this.ipaddr = true;
        this.addIPAddr = "新增IP地址";
        this.formData.ipStr = "";
        this.formData.ispId = "";
        this.formData.ports = [];
        this.formData.portRange = [];
        this.formData.ports.push({
          value: null
        });
        this.formData.portRange.push({
          start: null,
          end: null
        });
      },
      resetForm() {
        this.ipaddr = false;
        this.netcontact = false
      },
      convertIpStr( item ){
        if(item.ipType == 2){
          return "内网"
        }else {
          return "外网"
        }
      },
      convertPortStr( item ) {
        let _portArray = []
        if (item.portArray) {
          _portArray = _portArray.concat(item.portArray)
        }
        if (item.portRange) {
          item.portRange.forEach(e => {
            _portArray.push(e.start + "-" + e.end)
          })
        }
        let _returnStr = _portArray.join(",");

        return _returnStr
      },
      contact(item) {
        this.selectNetplane=""
        this.currentRow = null
        this.ipItem = item
        this.netcontact = true
        let _this = this;
        _this.$nextTick(() => {
          this.$refs.singleTable.setCurrentRow(null);
          _this.wanNetPlaneList.forEach((data, index) => {
            if (
              data && data.id == item.netPlaneId
            ) {
              _this.$refs.singleTable.setCurrentRow(data);
            }
          });
        });

      },
      saveIpBindNetPlane() {
        if (this.currentRow == null) {
          this.$message.warning('请选择网络平面')
          return;
        }

        let data = {
          'id': this.ipItem.id,
          'netPlaneId': this.currentRow.id
        };
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55, 55, 55, 0.4)'
        });
        let _this = this;

        this.$axios.post(this.baseUrl3 + 'management3/netip/netplane/bind', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.initData();
              this.selectNetplane="";
              _this.netcontact = false;
              _this.$message.success("操作成功！");
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              loading.close();
            }, 2000);
            // loading.close();
          })
      },
      delIpConfirm( id ){
        this.$confirm('您确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delIp(id)
        }).catch(() => {

        });
      },
      delIp(id) {
        let data = {
          'id': id,
        };
        let _this = this;

        this.$axios.post(this.baseUrl3 + 'management3/netip/delete', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.initData();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.initData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.initData()
      },
      selectCurrentChange(val) {
        if (val){
          this.currentRow = val;
          this.selectNetplane="已选择： "+val.netPlaneName+" ( id:"+val.id+" )"
        }else {
          this.selectNetplane=""
        }

        // this.$message.success(msg)
      },
      saveIp(formData) {
        this.$refs[formData].validate((valid) => {
          if (valid) {
            if (this.formData.ports[0].value==null && this.formData.portRange[0].start==null && this.formData.portRange[0].end==null){
              this.$message.warning("请输入端口或端口范围！")
              return
            }
            const loading = this.$loading({
              lock: true,
              text: '加载中...',
              // spinner: 'el-icon-loading',
              background: 'rgba(55, 55, 55, 0.4)'
            });
            let portArray = [];
            for (let content of this.formData.ports) {
              if (content.value != null && content.value != "") {
                portArray.push(Number(content.value))
              }
            }
            let portRange = [];
            for (let content of this.formData.portRange) {
              if (content.start != null && content.end != null) {
                portRange.push({
                  start: Number(content.start),
                  end: Number(content.end)
                })
              }
            }
            var data = {
              'ipStr': this.formData.ipStr,
              'ispId': this.formData.ispId,
              'ipType': 1,
              'portArray': portArray,
              'portRange': portRange,
              'idcId': this.idcId,
              'id': this.id,
              "netPlaneId":this.netPlaneId,
            };
            var _this = this;
            this.$axios.post(this.baseUrl3 + 'management3/netip/update', data)
              .then(({data: {msg, data, code}}) => {
                if (code == 20000) {
                  _this.ipaddr = false;
                  _this.initData();
                  _this.$message.success("操作成功！");
                } else {
                  _this.$message({showClose: true, message: msg, type: 'error'})
                  console.log(msg)
                }
                loading.close();
              })
              .catch(err => {
                console.log(err)
                setTimeout(() => {
                  loading.close();
                }, 1000);
                // loading.close();
              })
          } else {
            console.log('请确保端口信息正确且完整');
            return false;
          }
        });
      },
      initData() {
        let data = {
          'pageNo': this.currentPage,
          'pageSize': this.pageSize,
          'idcId': this.idcId,
        };
        let _this = this;
        _this.tableData = [];
        // _this.totalElement = 0;

        this.$axios.post(this.baseUrl3 + 'management3/netip/listWithIdcId', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if(data && data.IpList){
                data.IpList.forEach( (e,idx) => {
                  e.rowKey = e.id +"";
                  if(e.children){
                    e.children.forEach( child =>{
                      child.rowKey =e.id +"_" +child.ipStr
                    })
                  }
                })
              }
              _this.tableData = data && data.IpList ? data.IpList:[];
              // _this.tableData = data.IpList;
              _this.totalElement = data.total;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },

      initNetPlaneData() {
        var data = {};
        var _this = this;

        _this.netPlaneList = []
        _this.wanNetPlaneList = [];

        this.$axios.post(this.baseUrl3 + 'management3/netplane/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.wanNetPlaneList = data.wanNetPlaneList;
              _this.netPlaneList = data.netPlaneList;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initIsp() {
        let _this = this;

        _this.ispList = []
        this.$axios.post(this.baseUrl3 + 'management3/netip/isplist', {})
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.ispList = data;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      addPort() {
        this.formData.ports.push({
          value: null
        });
      },
      delPort(idx) {
        this.formData.ports.splice(idx, 1);
      },
      addRange() {
        this.formData.portRange.push({
          start: null,
          end: null
        });
      },
      delRange(idx) {
        this.formData.portRange.splice(idx, 1);
      },
    },
    created() {
      this.getListOperations('idclist');
      if (!this.currentMenu) {
        return
      }
      this.idcId = parseInt(this.$route.params.idcId);
      this.initData();
      this.initIsp();
      this.initNetPlaneData();
    }
  }
</script>

<style scoped>
  .portDiv {
    margin-bottom: 20px;
  }
  .el-loading-spinner {
    background-image:url('../../../assets/loading1.svg');
    background-size:63px 100px;
    background-repeat: no-repeat;
    height:30%;
    background-position:center;
    top:200px;
  }
  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
</style>
